module.exports = "p {\r\n    font-size: 18px;\r\n    margin-bottom: 5px;\r\n}"